import PLANS_PATH from '../../constants/path'
import { createSelector } from 'reselect'
import {
  compactObjectUtil,
  getObjectUtil
  , pickObjectUtil
} from 'packages/src'

const getRecommendedDomainMapPlansSelect = createSelector(state => getObjectUtil(
  state,
  PLANS_PATH.DATA
),
state => getObjectUtil(state, PLANS_PATH.RECOMMENDED_DATA),
(domainMap, recommendedDomainListData) => {
  return {
    ...compactObjectUtil(pickObjectUtil(domainMap, recommendedDomainListData))
  }
}
)

export default getRecommendedDomainMapPlansSelect
